// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack } from '@mantine/core';

import { MobileBasePageHeader } from 'components/Mantine/MobileBasePageHeader';
import { WorkOrderActivityFeed } from 'modules/Shop/WorkOrders/WorkOrderDetail/WorkOrderActivityFeed';
import type { WorkOrderDetailPageProps } from 'modules/Shop/WorkOrders/WorkOrderDetail/WorkOrderDetailPage';

export const MobileWorkOrderActivityView = ({ workOrder }: WorkOrderDetailPageProps) => (
  <Stack flex={1} mih={0} w="100%" p="md" pb={0} gap="xs">
    <MobileBasePageHeader
      title={workOrder.identifier}
      parentPage={{ title: workOrder.identifier, url: `/work-orders/${workOrder.workOrderId}` }}
      hideGlobalFilters
    />
    <Stack flex={1} style={{ overflowY: 'auto' }} gap="md">
      <WorkOrderActivityFeed workOrder={workOrder} />
    </Stack>
  </Stack>
);
